var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.417,
    height: 14.417,
    viewBox: "0 0 14.417 14.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.31;}.b{fill:#181818;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.24,24.393l-3.466-3.466a6.071,6.071,0,1,0-.85.85L24.39,25.24a.6.6,0,0,0,.85-.847Zm-8.165-2.451a4.868,4.868,0,1,1,4.869-4.866A4.873,4.873,0,0,1,17.076,21.942Z",
    transform: "translate(-11 -11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.27744608.svg";
export { ForwardRef as ReactComponent };